import { defineStore } from "pinia";

export const useAuthSessionStore = defineStore("authSession", {
    state: () => ({
        phoneNumber: null as string | null,
        fullLoginInitiated: false,
    }),

    actions: {
        setPhoneNumber(phone: string) {
            this.phoneNumber = phone;
        },
        setFullLoginInitiated(value: boolean) {
            this.fullLoginInitiated = value;
        },
        reset() {
            this.phoneNumber = null;
            this.fullLoginInitiated = false;
        }
    }
});
